/** Notice when a market close cancels pending limit/SL orders on the same script. */
export function pendingOrdersCancelledNote(message) {
  const text = String(message || '').toLowerCase();
  if (text.indexOf('pending orders canceled') === -1 && text.indexOf('pending orders cancelled') === -1) {
    return '';
  }
  return ' Pending limit/SL orders on this script were cancelled.';
}
